<template>
	<div class="title">
		<span class="label" v-if="quType">{{quType==1?'单选':quType==2?'多选':quType==3?'判断':'default'}}</span>
		<span>{{title}}</span>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				
			}
		},
		props:{
			quType:{
				type:[String,Number],
				default:''
			},
			title:{
				type:String,
				default:''
			},
		}
	}
</script>

<style scoped lang="scss">
	.title{
		line-height: 2;
		font-size: 16px;
	}
	.label{
		margin-right: 30px;
		padding: 5px 20px;
		background-color: #3964E6;
		color: #fff;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
	}
</style>
